class SortBar {
    private enableRelevanceSorting?: boolean;
    private currentSortOrder: number;
    private currentSortOptionValue: SortEnum;
    private sortChangeCallback: () => void;

    private ascSortOrder = 1;
    private descSortOrder = -1;

    private sortBarContainer: JQuery;

    constructor(
        sortChangeCallback: () => void,
        listSortConfig?: {
            enableRelevanceSorting?: boolean,
            key: string,
            direction: string,
        })
    {
        this.currentSortOrder = this.ascSortOrder;
        this.currentSortOptionValue = SortEnum.Title;

        // The dictionary and grammar modules can override the defaults through
        // .../wwwroot/content/BibliographyConfiguration/configuration.json and
        // .../wwwroot/Areas/OldGrammar/content/BibliographyPlugin/list_configuration.json, respectively
        if (listSortConfig) {
            this.enableRelevanceSorting = listSortConfig.enableRelevanceSorting;
            this.currentSortOrder = listSortConfig.direction == 'asc' ? this.ascSortOrder : this.descSortOrder;
            this.currentSortOptionValue = SortEnum[listSortConfig.key];
        }

        this.sortChangeCallback = sortChangeCallback;
    }

    public makeSortBar(sortBarContainer: string): HTMLDivElement {
        this.sortBarContainer = $(sortBarContainer);

        var sortBarDiv: HTMLDivElement = document.createElement('div');
        $(sortBarDiv).addClass('bib-sortbar');

        var select: HTMLSelectElement = document.createElement('select');

        $(select).on('change', () =>
        {
            let selectedOptionValue: string = this.sortBarContainer.find('div.bib-sortbar').find('select').find("option:selected").val() as string;
            let intValue = parseInt(selectedOptionValue);

            // Ensure "relevance" or "priority" sorting is descending by default
            // and sorting by the other keys is ascending -- upon selection.
            if (this.isSortedAsc() && intValue == SortEnum.Relevance) {
                this.currentSortOrder = this.descSortOrder;

            } else if (!this.isSortedAsc() && this.currentSortOptionValue == SortEnum.Relevance) {
                this.currentSortOrder = this.ascSortOrder;
            }

            this.changeSortCriteria(intValue);
            this.updateSortOrderButton();
        });

        // XXX: these options should be "module"/area-specific
        // XXX: the listSortConfig (list-sorting) actually makes that so
        if (this.enableRelevanceSorting)
        this.addOption(select, localization.translate("RelevanceSort", "PluginsJs").value, SortEnum.Relevance.toString());

        this.addOption(select, localization.translate("TitleSort", "PluginsJs").value, SortEnum.Title.toString());
        this.addOption(select, localization.translate("DatingSort", "PluginsJs").value, SortEnum.Dating.toString());
        this.addOption(select, localization.translate("AuthorSort", "PluginsJs").value, SortEnum.Author.toString());
        this.addOption(select, localization.translate("IntroductionYearSort", "PluginsJs").value, SortEnum.IntroductionYear.toString());

        sortBarDiv.appendChild(select);

        var sortOrderButton: HTMLButtonElement = document.createElement('button');
        sortOrderButton.type = 'button';
        $(sortOrderButton).addClass('btn btn-sm sort-button');

        var spanSortAsc: HTMLSpanElement = document.createElement('span');
        // glyphicon-arrow-up/down is added later by updateSortOrderButton invoked by BibliographyModule
        // XXX: but itjakub.bohemiantextbank.search.ts should also be updated...
        $(spanSortAsc).addClass('glyphicon');
        sortOrderButton.appendChild(spanSortAsc);

        $(sortOrderButton).on('click', () =>
        {
            this.toggleSortOrder();
            this.updateSortOrderButton();
        });

        sortBarDiv.appendChild(sortOrderButton);

        return sortBarDiv;
    }

    // XXX: they say this is unused
    private sort(comparator: (a: HTMLLIElement, b: HTMLLIElement) => number, order: number, booksContainer: string) {
        var elems: Array<HTMLLIElement> = <Array<HTMLLIElement>><any>$(booksContainer).children('ul.bib-listing').children('li').detach();
        var sortFunction = (a, b) => { return order * comparator(a, b); };
        elems.sort(sortFunction);
        $(booksContainer).children('ul.bib-listing').append(elems);
    }

    private toggleSortOrder()
    {
        this.currentSortOrder = (this.currentSortOrder === this.ascSortOrder) ? this.descSortOrder : this.ascSortOrder;
        this.sortingChanged();
    }

    private changeSortCriteria(sortOptionValue: SortEnum) // sort "criterion" or "key"
    {
        this.currentSortOptionValue = sortOptionValue;
        this.sortingChanged();
    }

    private sortingChanged() {
        this.sortChangeCallback();
    }

    private addOption(selectbox: HTMLSelectElement, text: string, value: string) {
        var option: HTMLOptionElement = document.createElement('option');
        option.text = text;
        option.value = value;
        selectbox.appendChild(option);
    }

    public isSortedAsc(): boolean {
        return this.currentSortOrder === this.ascSortOrder;
    }

    public setSortedAsc(sortAsc: boolean) {
        this.currentSortOrder = sortAsc ? this.ascSortOrder : this.descSortOrder;
        this.updateSortOrderButton();
    }

    // called by “ModulInicializator”: editionBasicSearchPaged (yep, even in the case of dictionaries)
    public getSortCriteria(): SortEnum {
        return this.currentSortOptionValue;
    }

    public setSortCriteria(sortCriteria: SortEnum) {
        this.currentSortOptionValue = sortCriteria;
        this.updateSelectedOption();
    }

    public updateSelectedOption()
    {
        this.sortBarContainer.find('div.bib-sortbar').find('select').val(this.currentSortOptionValue.toString());
    }

    public updateSortOrderButton()
    {
        // XXX: why not store this.sortOrderButtonIcon?
        let sortOrderButtonIcon = this.sortBarContainer.find('div.bib-sortbar').find('.sort-button').find(".glyphicon");
        $(sortOrderButtonIcon).removeClass("glyphicon-arrow-up glyphicon-arrow-down");
        this.isSortedAsc() ? $(sortOrderButtonIcon).addClass("glyphicon-arrow-up") : $(sortOrderButtonIcon).addClass("glyphicon-arrow-down");
    }
}

/*
 * Mirroring of C# datacontract in namespace ITJakub.Shared.Contracts.Searching.Criteria
 *
 * [DataContract]
    public enum SortEnum : short
    {
        [EnumMember]
        Author = 0,
        [EnumMember]
        Title = 1,
        [EnumMember]
        Dating = 2,
    }
 */

enum SortEnum {
    Author = 0,
    Title = 1,
    Dating = 2,
    Relevance = 3,
    IntroductionYear = 4,
}

enum SortDirection {
    Asc = 0,
    Desc = 1,
}
